import { createReducer } from "reduxsauce";
import Immutable from "seamless-immutable";
import { PlanGroupTypes } from "./plan-group-actions";

/* ------------- Initial State ------------- */

export const INITIAL_STATE=Immutable({
  fetchingplanGroupsGraphed: false,
  fetchingplanGroupsGraphedAll: false,
  fetchingplanGroups: false,
  fetchingArchived:false,
  fetchingPlan:false,
  creating: false,
  updating: false,
  addingWatcher: false,
  removingWatcher: false,
  fetchingProductWatcher: false,
  creatingLeaderBoard: false,
  planGroupsGraphed: null,
  planGroupsGraphedAll: null,
  planGroups: null,
  archiving: null,
  plan:null,
  createdPlanGroup: null,
  updatedPlanGroup: null,
  watcher: null,
  removeWatcher: null,
  productWatcher: null,
  boardUrl: null,
  errorArchiving: null,
  errorplanGroupsGraphed: null,
  errorplanGroupsGraphedAll: null,
  errorplanGroups: null,
  errorPlan: null,
  errorCreating: null,
  errorUpdating: null,
  errorAddingWatcher: null,
  errorRemovingWatcher: null,
  errorProductWatcher: null,
  errorBoardUrl: null,
});

/* ------------- Reducers ------------- */

// request the data from an api
export const graphedRequest = (state) => {
	return { ...state, fetchingplanGroupsGraphed: true,  planGroupGraphed: null };
};
export const graphedAllRequest = (state) => {
	return {
		...state,
		fetchingplanGroupsGraphedAll: true,
		planGroupsGraphedAll: null,
		errorplanGroupsGraphedAll: null,
	};
};
export const planGroupsRequest = (state) => {
	return { ...state, fetchingplanGroups: true, planGroups: null };
};

// request to archive from an api
export const archiveRequest = (state) => {
	return { ...state, archiving: true};
};
// request to get plan from an api
export const planRequest = (state) => {
	return { ...state, fetchingPlan: true, plan:null, errorPlan: null};
};

export const createRequest = (state) => {
	return { ...state, creating: true, createdPlanGroup: null, errorCreating: null };
};

export const updateRequest = (state) => {
	return { ...state, updating: true, updatedPlanGroup: null, errorUpdating: null };
};

export const addWatcherRequest = (state) => {
	return { ...state, addingWatcher: true, watcher: null, errorAddingWatcher: null };
};

export const removeWatcherRequest = (state) => {
	return { ...state, removingWatcher: true, removeWatcher: null, errorRemovingWatcher: null };
};

export const getProductWatcherRequest = (state) => {
	return { ...state, fetchingProductWatcher: true, productWatcher: null, errorProductWatcher: null };
};

export const leaderBoardRequest = (state) => {
	return { ...state, creatingLeaderBoard: true, boardUrl: null, errorBoardUrl: null };
};

// successful api lookup for all entities
export const graphedSuccess = (state, action) => {
	const { planGroupsGraphed } = action;
	return {
		...state,
		fetchingplanGroupsGraphed: false,
		errorplanGroupsGraphed: null,
		planGroupsGraphed,
	};
};
export const graphedAllSuccess = (state, action) => {
	const { planGroupsGraphedAll } = action;
	return {
		...state,
		fetchingplanGroupsGraphedAll: false,
		errorplanGroupsGraphedAll: null,
		planGroupsGraphedAll,
	};
};
export const planGroupsSuccess = (state, action) => {
	const { planGroups } = action;
	return {
		...state,
		fetchingplanGroups: false,
		errorplanGroups: null,
		planGroups,
	};
};

 // successful archiving delete
export const archiveSuccess = (state) => {
	return { ...state, archiving: false, errorArchiving: null, fetchingArchived: null };
};
 // successful plan get
export const planSuccess = (state, action) => {
	const {plan} = action
	return { ...state, fetchingPlan: false, plan, errorPlan: null };
};

export const createSuccess = (state, action) => {
	const { createdPlanGroup } = action;
	return { ...state, creating: false, createdPlanGroup, errorCreating: null };
};

export const updateSuccess = (state, action) => {
	const { updatedPlanGroup } = action;
	return { ...state, updating: false, updatedPlanGroup, errorUpdating: null };
};

export const addWatcherSuccess = (state, action) => {
	const { watcher } = action;
	return { ...state, addingWatcher: false, watcher, errorAddingWatcher: null };
};

export const removeWatcherSuccess = (state, action) => {
	const { watcherId } = action;
	return { ...state, removingWatcher: false, removeWatcher: watcherId, errorRemovingWatcher: null };
};

export const productWatcherSuccess = (state, action) => {
	const { watcher } = action;
	return { ...state, fetchingProductWatcher: false, productWatcher: watcher, errorProductWatcher: null };
};

export const leaderBoardSuccess = (state, action) => {
	const { boardUrl } = action;
	return { ...state, creatingLeaderBoard: false, boardUrl, errorBoardUrl: null };
};

// Something went wrong fetching all entities.
export const graphedFailure = (state, action) => {
	const { error } = action;
	return {
		...state,
		fetchingplanGroupsGraphed: false,
		errorplanGroupsGraphed: error,
		planGroupsGraphed: null,
	};
};
export const graphedAllFailure = (state, action) => {
	const { error } = action;
	return {
		...state,
		fetchingplanGroupsGraphedAll: false,
		errorplanGroupsGraphedAll: error,
		planGroupsGraphedAll: null,
	};
};
export const planGroupsFailure = (state, action) => {
	const { error } = action;
	return {
		...state,
		fetchingplanGroups: false,
		errorplanGroups: error,
		planGroups: null,
	};
};

  // Something went wrong archiving.
export const archiveFailure = (state, action) => {
	const { error } = action;
	return {
		...state,
		archiving: false,
		fetchingArchived: null,
		errorArchiving: error,
	};
};

  // Something went wrong archiving.
export const planFailure = (state, action) => {
	const { error } = action;
	return {
		...state,
		fetchingPlan: false,
		plan: null,
		errorPlan: error,
	};
};

export const createFailure = (state, action) => {
	const { error } = action;
	return {
		...state,
		creating: false,
		createdPlanGroup: null,
		errorCreating: error,
	};
};

export const updateFailure = (state, action) => {
	const { error } = action;
	return {
		...state,
		updating: false,
		updatedPlanGroup: null,
		errorUpdating: error,
	};
};

export const addWatcherFailure = (state, action) => {
	const { error } = action;
	return { ...state, addingWatcher: false, watcher: null, errorAddingWatcher: error };
};

export const removeWatcherFailure = (state, action) => {
	const { error } = action;
	return { ...state, removingWatcher: false, removeWatcher: null, errorRemovingWatcher: error };
};

export const productWatcherFailure = (state, action) => {
	const { error } = action;
	return { ...state, fetchingProductWatcher: false, productWatcher: null, errorProductWatcher: error };
};

export const leaderBoardFailure = (state, action) => {
	const { error } = action;
	return { ...state, creatingLeaderBoard: false, boardUrl: null, errorBoardUrl: error };
};


  /* ------------- Hookup Reducers To Types ------------- */

  export const reducer = createReducer(INITIAL_STATE, {
     [PlanGroupTypes.PLAN_GROUP_GRAPHED_ACTIVE_REQUEST]: graphedRequest,
     [PlanGroupTypes.PLAN_GROUP_GRAPHED_ALL_REQUEST]: graphedAllRequest,
     [PlanGroupTypes.PLAN_GROUPS_REQUEST]: planGroupsRequest,
    [PlanGroupTypes.PLAN_GROUP_GRAPHED_ARCHIVED_REQUEST]:archiveRequest,
    [PlanGroupTypes.PLAN_REQUEST]:planRequest,
    [PlanGroupTypes.PLAN_GROUP_CREATE_REQUEST]: createRequest,
    [PlanGroupTypes.PLAN_GROUP_UPDATE_REQUEST]: updateRequest,
    [PlanGroupTypes.ADD_WATCHER_REQUEST]: addWatcherRequest,
    [PlanGroupTypes.REMOVE_WATCHER_REQUEST]: removeWatcherRequest,
    [PlanGroupTypes.GET_PRODUCT_WATCHER_REQUEST]: getProductWatcherRequest,
    [PlanGroupTypes.LEADER_BOARD_REQUEST]: leaderBoardRequest,

    [PlanGroupTypes.PLAN_GROUP_GRAPHED_ACTIVE_SUCCESS]: graphedSuccess,
    [PlanGroupTypes.PLAN_GROUP_GRAPHED_ALL_SUCCESS]: graphedAllSuccess,
    [PlanGroupTypes.PLAN_GROUPS_SUCCESS]: planGroupsSuccess,
    [PlanGroupTypes.PLAN_GROUP_GRAPHED_ARCHIVED_SUCCESS]:archiveSuccess,
    [PlanGroupTypes.PLAN_SUCCESS]:planSuccess,
    [PlanGroupTypes.PLAN_GROUP_CREATE_SUCCESS]: createSuccess,
    [PlanGroupTypes.PLAN_GROUP_UPDATE_SUCCESS]: updateSuccess,
    [PlanGroupTypes.ADD_WATCHER_SUCCESS]: addWatcherSuccess,
    [PlanGroupTypes.REMOVE_WATCHER_SUCCESS]: removeWatcherSuccess,
    [PlanGroupTypes.PRODUCT_WATCHER_SUCCESS]: productWatcherSuccess,
    [PlanGroupTypes.LEADER_BOARD_SUCCESS]: leaderBoardSuccess,
   
    [PlanGroupTypes.PLAN_GROUP_GRAPHED_ACTIVE_FAILURE]: graphedFailure,
    [PlanGroupTypes.PLAN_GROUP_GRAPHED_ALL_FAILURE]: graphedAllFailure,
    [PlanGroupTypes.PLAN_GROUPS_FAILURE]: planGroupsFailure,
    [PlanGroupTypes.PLAN_GROUP_GRAPHED_ARCHIVED_FAILURE]:archiveFailure,
    [PlanGroupTypes.PLAN_FAILURE]:planFailure,
    [PlanGroupTypes.PLAN_GROUP_CREATE_FAILURE]: createFailure,
    [PlanGroupTypes.PLAN_GROUP_UPDATE_FAILURE]: updateFailure,
    [PlanGroupTypes.ADD_WATCHER_FAILURE]: addWatcherFailure,
    [PlanGroupTypes.REMOVE_WATCHER_FAILURE]: removeWatcherFailure,
    [PlanGroupTypes.PRODUCT_WATCHER_FAILURE]: productWatcherFailure,
    [PlanGroupTypes.LEADER_BOARD_FAILURE]: leaderBoardFailure,
})